import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import { Box, Container, Paper, Typography, useTheme } from '@mui/material'
import { useAppSelector } from '@hooks/redux'

const AuthLayout: React.FC = () => {
  const theme = useTheme()
  const { isAuthenticated } = useAppSelector((state) => state.auth)

  // Redirect to home if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[50],
        backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.light}22 0%, ${theme.palette.secondary.light}22 100%)`,
        py: 3,
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 'bold',
              color: 'primary.main',
              mb: 1,
            }}
          >
            Smart Nyuki
          </Typography>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            sx={{ mb: 4 }}
          >
            Helping beekeepers make informed decisions about their colonies
          </Typography>
        </Box>

        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 4 },
            borderRadius: 2,
            backgroundColor: 'white',
          }}
        >
          <Outlet />
        </Paper>

        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Typography variant="body2" color="textSecondary">
            © 2024 Smart Nyuki. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default AuthLayout
